module.exports = __webpack_public_path__ + "static/media/Jeep-Wrangler-JL.14f0b92a.webp";